module.exports = __webpack_public_path__ + "img/mobile-6.f0d1c79c.jpg";